import React from 'react';
import './theme.scss';
import PropTypes from "prop-types";

function Theme(props) {
    const {brand, theme} = props;
    const className = `theme theme-${brand}-${theme}`;

    return (
        <div className={className}>
            {props.children}
        </div>
    );
}

Theme.propTypes = {
    brand: PropTypes.string,
    theme: PropTypes.string,
    children: PropTypes.any,
};

export default Theme;
